import { useHistory } from 'react-router-dom';

export default function CoachingSessionModal() {
  const history = useHistory();
  const { location } = history;
  const newPathname = location.pathname.replace(
    'coaching-session',
    'one_on_ones',
  );
  const url = `${window.location.origin}${newPathname}${location.search}`;
  window.open(url); // open in a new tab
  return null; // don't dispay modal
}
